import {SchemasOrderFamilyPayUser} from '@shared/schemas/order'

import {FamilyPayUserStatusValues} from '@web/core/constants'
import getApi, {createApiAsyncThunk, createWrapper} from '@web/helpers/api'

import {MemberThunkApi as ThunkApi} from '../interfaces'

const api = getApi('/orderApi/orderSheet/familyPayUser')

/** 패밀리 결제 초기화 action */
export const initFamilyPayUser = createApiAsyncThunk<
    {
        subscribeType: FamilyPayUserStatusValues
        name?: string
    },
    {
        entry: string
    },
    ThunkApi
>(
    'familyPayUser/init',
    async ({entry}) => {
        const response = await createWrapper<SchemasOrderFamilyPayUser['/']['response']>(
            api.get('/', {
                params: {entry},
            }),
        )

        const result = {
            subscribeType: response.subscribeType,
            name: response.name,
        }

        return result
    },
    {
        passAuth: () => ({
            subscribeType: 'AUTH',
        }),
    },
)

/** 패밀리 결제 가입 정보 조회 action */
export const getFamilyPayUser = createApiAsyncThunk<
    {
        subscribeType: FamilyPayUserStatusValues
        isAgreed: boolean
    },
    {
        entry: string
    },
    ThunkApi
>('familyPayUser/checkAgree', async ({entry}) => {
    const response = await createWrapper<SchemasOrderFamilyPayUser['/agree']['response']>(
        api.get('/agree', {
            params: {entry},
        }),
    )

    return {
        subscribeType: response.subscribeType,
        isAgreed: response.agreed === 'Y',
    }
})

/** 패밀리 맴버 정보 조회 action */
export const getFamilyPayUserMemberInfo = createApiAsyncThunk<
    {
        hasMember: boolean
    },
    {
        entry: string
    },
    ThunkApi
>('familyPayUser/getMemberInfo', async ({entry}) => {
    return createWrapper<SchemasOrderFamilyPayUser['/agree/member']['response']>(
        api.get('/agree/member', {
            params: {entry},
        }),
    )
})

/** 패밀리 결제 동의 action */
export const agreeFamilyPayUser = createApiAsyncThunk<boolean, void, ThunkApi>('familyPayUser/agree', async () => {
    return createWrapper<SchemasOrderFamilyPayUser['POST/agree']['response']>(
        api.post('/agree', {
            subscriptionPathUrl: window.location.href,
        }),
    )
})

/** 패밀리 결제 철회 action */
export const withdrawFamilyPayUser = createApiAsyncThunk<
    {
        status: 'DISAGREE' | 'WITHDRAW' | 'UNKNOWN'
    },
    void,
    ThunkApi
>('familyPayUser/withdraw', async () => {
    return createWrapper<SchemasOrderFamilyPayUser['/withdraw']['response']>(api.post('/withdraw'))
})

/** 패밀리 결제 맴버 동의 철회 action */
export const withdrawMemberFamilyPayUser = createApiAsyncThunk<
    {
        status: 'DISAGREE' | 'WITHDRAW' | 'UNKNOWN'
    },
    void,
    ThunkApi
>('familyPayUser/withdrawMember', async () => {
    return createWrapper<SchemasOrderFamilyPayUser['/member/withdraw']['response']>(api.post('/member/withdraw'))
})

/**
 * 패밀리결제 알림
 */
export const validNotifyFamilyPayUser = createApiAsyncThunk<{subscribeType: FamilyPayUserStatusValues}, void, ThunkApi>(
    'familyPayUser/validNotify',
    async () => {
        return createWrapper<SchemasOrderFamilyPayUser['/notify']['response']>(api.get('/notify'))
    },
)

/**
 * 패밀리결제 알림
 */
export const notifyFamilyPayUser = createApiAsyncThunk<
    void,
    {
        notificationType: 'BIZTALK' | 'SMS' | 'KAKAO_TALK'
    },
    ThunkApi
>('familyPayUser/notify', async ({notificationType}) => {
    // 카카오톡 구현 필요
    if (notificationType === 'KAKAO_TALK') {
        return
    }
    const result = await createWrapper<SchemasOrderFamilyPayUser['POST/notify']['response']>(
        api.post('/notify', {
            type: notificationType,
        }),
    )

    return result
})
